/** @format */

export const validateForm = (obj, model) => {
  let errors = [];
  model.forEach(item => {
    if (
      obj[item.name] === undefined ||
      obj[item.name] === null ||
      obj[item.name] === ''
    ) {
      errors.push(item.name);
    }
    if (item.name === 'price' && obj[item.name] === 0) {
      errors.push(item.name);
    }
  });
  return errors;
};

/**
 * Verifica se il parametro passato ha un valore di qualsiasi tipo
 * @param {*} value
 */
export function hasValue(value) {
  return value !== '' && value !== null && value !== undefined;
}

export const formModels = {
  communication: [
    {
      name: 'state',
      required: true,
    },
    {
      name: 'recallDate',
      required: true,
    },
    {
      name: 'recallHour',
      required: true,
    },
    {
      name: 'recallMinutes',
      required: true,
    },
  ],
  reqPart: [
    {
      name: '_carVersion',
      required: true,
    },
    {
      name: '_carModel',
      required: true,
    },
    {
      name: '_carMaker',
      required: true,
    },
    {
      name: 'carVersion',
      required: true,
    },
    {
      name: 'carModel',
      required: true,
    },
    {
      name: 'carMaker',
      required: true,
    },
    {
      name: '_part',
      required: true,
    },
    {
      name: 'part',
      required: true,
    },
    {
      name: 'whCode',
      required: true,
    },
    {
      name: 'partCondition',
      required: true,
    },
  ],
  reqPartOption: [
    {
      name: 'price',
      required: true,
    },
  ],
  boxes: [
    {
      name: '_method',
      required: true,
    },
    {
      name: 'method',
      required: true,
    },
    {
      name: 'price',
      required: true,
    },
  ],
};
